import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";
import { showApiErrorToast } from "../utils/helpers";

const fetchVisitPhotos = async ({ visitId, patientId, sessionId, stepId }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  if (patientId) params.append("patient_id", patientId);
  if (sessionId) params.append("session_id", sessionId);
  if (stepId) params.append("step_id", stepId);

  const res = await axios.get(
    `${__API_URL__}/api/photos/visits/${visitId}/photos/?${params.toString()}`,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return res.data;
};

const useGetVisitPhotos = ({ visitId, patientId, sessionId, stepId, enabled = true }) => {
  return useQuery({
    queryKey: ["visit_photos", visitId, patientId, sessionId, stepId],
    queryFn: () => fetchVisitPhotos({ visitId, patientId, sessionId, stepId }),
    enabled: enabled && Boolean(visitId),
    onError: (error) => {
      showApiErrorToast(error, "Failed to load visit photos");
    },
  });
};

export default useGetVisitPhotos;
